module.exports = __webpack_public_path__ + "img/eye.26941ffd.svg";